// @flow

import * as React from 'react';
import useSheet from 'app/jss';
import classNames from 'classnames';
import Tappable from 'app/components/commons/Tappable';
import AnimatedGroup from 'app/components/commons/AnimatedGroup';
import { makeSimpleButtonStyle } from '../../utils/buttonUtils';

type Props = {
  className?: string,
  kind?: 'white' | 'primary' | 'grey' | 'dark' | 'success',
  onClick?: () => void,
  classes: Object,
  size?: 'default',
  style?: Object,
  hitboxSize?: string | number,
  onRef?: () => React.Node,
  onEnter?: () => void,
  onLeave?: () => void,
  children?: any,
  circleClass?: string
};

class CircleButton extends React.Component {
  props: Props;

  static defaultProps = {
    className: undefined,
    kind: 'white',
    size: 'default',
    style: undefined,
    hitboxSize: undefined,
    onRef: undefined,
    onEnter: undefined,
    onLeave: undefined,
    children: undefined,
    circleClass: undefined,
    onClick: undefined
  };

  render() {
    const {
      className,
      classes,
      circleClass,
      kind,
      onClick,
      size,
      style,
      hitboxSize,
      onEnter,
      onLeave,
      children,
      ...otherProps
    } = this.props;
    const hitboxStyle = {};
    if (hitboxSize) {
      hitboxStyle.height = hitboxSize;
      hitboxStyle.width = hitboxSize;
    }

    return (
      <Tappable
        component="div"
        style={hitboxStyle}
        className={classNames(classes.hitbox, className)}
        onTap={onClick}
        {...otherProps}
      >
        <AnimatedGroup
          className={classNames(classes.circleButton, circleClass, classes[kind], classes[size])}
          style={style}
          onEnter={onEnter}
          onLeave={onLeave}
        >
          {children}
        </AnimatedGroup>
      </Tappable>
    );
  }
}

function applyStyles(theme: Theme) {
  const baseStyle = {
    hitbox: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    circleButton: {
      borderRadius: '50%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    default: {
      width: 26,
      height: 26
    }
  };

  const buttons = [
    {
      name: 'white',
      color: theme.color.basis3,
      background: theme.color.white,
      border: '1px solid currentColor'
    },
    { name: 'grey', color: theme.color.white, background: theme.color.basis4 },
    { name: 'success', color: theme.color.white, background: theme.color.success },
    { name: 'primary', color: theme.color.white, background: theme.color.primary },
    { name: 'dark', color: theme.color.white, background: theme.color.basis4 }
  ].map(config => makeSimpleButtonStyle(config, 'CircleButton'));
  return Object.assign(baseStyle, ...buttons);
}

export default useSheet(applyStyles)(CircleButton);
